<template>
  <el-dialog
    title
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="550px"
    class="edit-modal"
    @close="onClose"
  >
    <div slot="title" style="display: flex; align-items: center">
      <span>{{ drawRow.type === 'add' ? $t('paypal::setting::绑定账户') : $t('paypal::setting::编辑账户') }}</span>
      <span v-show="drawRow.type === 'add'" class="dialog-tip">
        <i class="icon-a-01wenhao iconfont-el"></i>
        <el-button type="text" @click="toGuider" style="font-size: 14px; padding: 0">
          {{ $t('paypal::setting::handle_tip') }}
        </el-button>
      </span>
    </div>

    <el-form class="user-body" ref="form" :model="params" :rules="rules" label-width="100px" v-loading="loading">
      <el-form-item :label="$t('paypal::setting::PayPal账户')" prop="accountName">
        <el-input
          :disabled="drawRow.type === 'edit'"
          v-model="params.accountName"
          :placeholder="$t('paypal::setting::Paypal账户_placeholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="'Client_id'" prop="clientId">
        <el-input
          :disabled="drawRow.type === 'edit' && params.bindStatus == 1"
          v-model="params.clientId"
          :placeholder="$t('paypal::setting::clientId_placeholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="'Secret'" prop="secret">
        <el-input
          :disabled="drawRow.type === 'edit' && params.bindStatus == 1"
          v-model="params.secret"
          :placeholder="$t('paypal::setting::secret_placeholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('paypal::setting::店铺')" prop="shopList">
        <el-select
          :popper-append-to-body="false"
          v-model="params.shopList"
          filterable
          multiple
          class="input-item"
          :placeholder="$t('paypal::setting::店铺_placeholder')"
          ref="shopSelect"
        >
          <el-option v-for="item in shopList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          <template slot="empty" v-if="$auth('stores::store::add')">
            <div class="empty-wrap">
              {{ $t('paypal::setting::查无数据') }}
              <el-button type="text" style="margin-left: 10px" @click="toBindShop">
                {{ $t('paypal::setting::去绑定') }}
              </el-button>
            </div>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('paypal::setting::有客户经理')" prop="hasManager">
        <el-radio-group v-model="params.hasManager">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onClose">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="onSave" :loading="saveLoading">
        {{ drawRow.type === 'add' ? $t('system::common::btn::绑定') : $t('system::common::btn::confirm') }}
      </el-button>
    </div>
    <EditDialog ref="edit" :isNew="true" @editAndadd="$store.dispatch('getShopList')"></EditDialog>
  </el-dialog>
</template>
<script>
import { setPaypalAccount } from '@/server/paypal.js'
import EditDialog from '@/views/store/components/editDialog'
export default {
  name: 'edit-modal',
  components: { EditDialog },

  props: {
    value: {},
    drawRow: {
      default: () => {},
    },
  },
  watch: {
    value(bool) {
      this.visible = bool
      const data = this.drawRow.data
      if (this.drawRow.type === 'add') {
        this.params = {
          accountName: '',
          clientId: '',
          secret: '',
          hasManager: 0,
          shopList: [],
          id: null,
        }
      } else {
        this.params = {
          accountName: data.accountName,
          clientId: data.clientId,
          secret: data.secret,
          hasManager: data.hasManager,
          shopList: data.shopList && data.shopList.length ? data.shopList.map(el => el.shopId) : [],
          id: data.id,
          bindStatus: data.bindStatus,
        }
        this.authError = this.drawRow.error || false
      }

      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        this.authError && this.$refs.form.validateField(['clientId', 'secret'], () => {})
        this.authError = false
      })
    },
    visible(val) {
      this.$emit('input', val)
    },
  },
  data() {
    const validateClientIdAuth = (rule, value, callback) => {
      if (this.authError) {
        callback(new Error(this.$t('paypal::setting::client_error')))
      } else {
        callback()
      }
    }
    const validateSecretAuth = (rule, value, callback) => {
      if (this.authError) {
        callback(new Error(this.$('paypal::setting::secret_error')))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      saveLoading: false,
      rules: {
        accountName: [{ required: true, message: this.$t('paypal::setting::Paypal账户_placeholder'), trigger: 'blur' }],
        clientId: [
          { required: true, message: this.$t('paypal::setting::clientId_placeholder'), trigger: 'blur' },
          { validator: validateClientIdAuth },
        ],
        secret: [
          { required: true, message: this.$t('paypal::setting::secret_placeholder'), trigger: 'blur' },
          { validator: validateSecretAuth },
        ],
      },
      visible: false,
      params: {},
      merchantId: this.$store.state.user.merchantId,
      authError: false,
    }
  },
  mounted() {},
  computed: {
    sourceType() {
      return this.$store.state.user.sourceType
    },
    shopList() {
      return this.$store.state.products.shopList
    },
  },
  methods: {
    toGuider() {
      window.open('https://docs.qq.com/doc/DTG1sQUdBVFlTTkZo', '_blank')
    },
    onClose() {
      this.visible = false
    },
    onSave() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.saveLoading = true
          let params = {
            ...this.params,
            shopList: this.params.shopList.map(el => {
              let item = this.shopList.find(item => item.value === el)
              return { shopId: item.value, shopName: item.label }
            }),
          }
          if (this.drawRow.type === 'add') {
            delete params.id
          }
          const { data } = await setPaypalAccount(params)
          if (data.code === this.$code) {
            if (this.drawRow.type === 'add') {
              window.location.href = data.data
              await this.$store.dispatch('getBindData')
            }
            this.$message.success(this.$t('system::tip::control_success'))
            this.onClose()
            this.$emit('save')
          }
          this.saveLoading = false
        }
      })
    },
    toBindShop() {
      this.$refs.shopSelect.blur() // 失焦隐藏下拉框
      this.$refs.edit.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.edit-modal {
  .user-body {
    .input-item {
      width: 100%;
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
.empty-wrap {
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.icon-a-01wenhao {
  margin: 0 4px 0 8px;
  font-size: 16px;
  color: #999;
}
.dialog-tip {
  display: flex;
  align-items: center;
}
</style>
